import React from "react";
import { observer } from "mobx-react";
import { PageLayout } from "../../../../common/layout";
import { useRootStore } from "../../../../store/contexts";
import { UserNotificationPreferenceView } from "./UserNotificationPreferenceView";
import { UserNotificationPreferenceViewStore } from "../../store/UserNotificationPreferenceViewStore";
import { useStore } from "../../../../hooks";

export const UserNotificationPreferenceViewPage = observer(() => {
  const rootStore = useRootStore();
  const { router } = rootStore;

  const id = router.params?.id as string;
  const path = `/userNotificationPreference/view/${id}`;

  const store = useStore(
    path,
    () => {
      const s = new UserNotificationPreferenceViewStore(rootStore);
      return s;
    },
    { id }
  );

  return (
    <div>
      <PageLayout
        navigationElements={{
          links: [],
          onNavigatedTo: (id) => {
            store.setCardState(id, true);
          },
        }}
      >
        <UserNotificationPreferenceView
          userNotificationPreferenceViewStore={store}
        />
      </PageLayout>
    </div>
  );
});
